import React, { Component } from 'react';
import Thumbnail from '../Lightbox/Thumbnail';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { uniq } from 'lodash';

function ItineraryItem({ activity, idx, galleryPrefix }) {
  return (
    <div className='fe-trip-it-item'>
      <div className='fe-trip-it-point'>
        <span className='fe-it-circle' />
        <div className='fe-it-line' />
      </div>
      <div className='fe-trip-it-details'>
        <div className='fe-trip-it-time'>{activity.time}</div>
        <div className='fe-trip-it-content'>
          <div className='fe-trip-it-text'>{activity.activity}</div>
          {activity.sub_text ? (
            <p
              className='fe-trip-it-subtext'
              dangerouslySetInnerHTML={{
                __html: activity.sub_text
              }}
            />
          ) : null}
          {activity.images && activity.images.length > 0 ? (
            <div className='fe-trip-it-gallery'>
              {activity.images.map((img, imgIdx) => (
                <figure key={img.id}>
                  <div className='fe-u-thumb-4by3'>
                    <Thumbnail
                      id={imgIdx}
                      galleryId={`${galleryPrefix}-itinerary-${idx}`}
                      src={img.img_url}
                      fullSrc={img.img_url}
                      alt=''
                      isFinalImage={imgIdx + 1 >= activity.images.length}
                    />
                  </div>
                  <figcaption>{img.name}</figcaption>
                </figure>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

class Itinerary extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      itinerary,
      theme,
      sidePhotos,
      galleryPrefix,
      t,
      byorSelected
    } = this.props;

    const uniqueDays = uniq(itinerary.map(activity => activity.day_no));
    const itDays = uniqueDays[0] === null ? ['1'] : uniqueDays;

    return (
      <section className={`fe-trip-itinerary ${theme}`}>
        {sidePhotos.length >= 2 ? (
          <>
            <div className='fe-trip-it-side-photo'>
              <img src={sidePhotos[0].img_url} alt='' />
            </div>
            <div className='fe-trip-it-side-photo bottom'>
              <img src={sidePhotos[1].img_url} alt='' />
            </div>
          </>
        ) : null}
        <div className='container'>
          <div className='row'>
            <div className='col-lg-8'>
              <h4 className='fe-trip-main-heading'>{t('trip:itinerary')}</h4>
              <div className='fe-trip-it-list'>
                {itDays.map((day, idx) => {
                  if (itDays.length > 1) {
                    return (
                      <React.Fragment key={idx}>
                        <div className='fe-trip-it-item'>
                          <div className='fe-trip-it-point'>
                            <span className='fe-it-circle' />
                            <div className='fe-it-line' />
                          </div>
                          <div className='fe-trip-it-details'>
                            <div className='fe-trip-it-day'>
                              {t('trip:dayNum', { num: day })}
                            </div>
                          </div>
                        </div>
                        {itinerary
                          .filter(activity => activity.day_no === day)
                          .map((activity, idx) => (
                            <ItineraryItem
                              key={idx}
                              idx={idx}
                              activity={activity}
                              galleryPrefix={galleryPrefix}
                            />
                          ))}
                      </React.Fragment>
                    );
                  } else {
                    return itinerary.map((activity, idx) => {
                      // if (
                      //   byorSelected &&
                      //   (idx === 0 || idx === itinerary.length - 1)
                      // )
                      //   return null;
                      return (
                        <ItineraryItem
                          key={idx}
                          idx={idx}
                          activity={activity}
                          galleryPrefix={galleryPrefix}
                        />
                      );
                    });
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ItineraryItem.propTypes = {
  activity: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  galleryPrefix: PropTypes.string.isRequired
};

Itinerary.propTypes = {
  itinerary: PropTypes.array.isRequired,
  theme: PropTypes.string.isRequired,
  sidePhotos: PropTypes.array.isRequired,
  galleryPrefix: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

Itinerary.defaultProps = {
  galleryPrefix: ''
};

export default withTranslation()(Itinerary);
